<template>
  <div class="join-container">
    <top-nav :shrinked="true"/>
    <div class="content">
      <div class="newsdetail-title">
        <span>{{dataInfo.title}}</span>
        <img src="@/assets/join/fire.png">
        <span>{{getDictText(salaryArr,dataInfo.salary)}}</span>
      </div>
      <div class="newsdetail-position">
        <span>{{getDictText(typeArr,dataInfo.type)}}</span>
        <span>|</span>
        <span>{{getDictText(addressArr,dataInfo.address)}}</span>
      </div>
      <div class="newsdetail-date">
        <span>发布时间：</span>
        <span>{{dataInfo.createTime}}</span>
      </div>
      <div class="newsdetail-line"></div>
<!--      <div>职位描述</div>-->
      <div class="newsdetail-content" v-html="dataInfo.content"></div>
<!--      <div class="newsdetail-work-title">岗位职责：</div>-->
<!--      <div>-->
<!--        <p>1.根据项目整体销售推广决策，承担项目市场定位、产品建议以及销售、推广整体计划的制定、推进与完成的责任;</p>-->
<!--        <p>2.制定项目整体及各阶段广告包装策划方案，制定各阶段推广主题及传播渠道，包含大众媒体广告;自媒体、活动、渠道拓展、销售促进、物料制作等方面推广工作，对项目推广的知名度及美誉度负责;</p>-->
<!--        <p>3.负责广告公司、媒体及各个供应商的对接，与其他各专业部门关于项目信息的沟通对接;</p>-->
<!--        <p>4.辅助营销经理、配合案场经理完成项目销售目标，并编写各阶段工作计划及总结汇报</p>-->
<!--        <p>5.负责房地产项目开发的后期营销策划的工作，如项目概念定位的成功演绎、各类营销手法的运用;</p>-->
<!--        <p>6.负责与相关媒体对接,搞好公司各类推广项目，做好活动的策划、包装、宣传、跟进等实施工作;</p>-->
<!--      </div>-->
<!--      <div class="newsdetail-work-title">岗位要求：</div>-->
<!--      <div>-->
<!--        <p>1.统招本科及以上学历，新闻、中文、媒体、设计等相关专业;</p>-->
<!--        <p>2.品质型标杆房企标杆品质房地产企业同岗位两年及以上经验;</p>-->
<!--        <p>3.江浙沪区域工作经历，具有高端豪宅、别墅等项目策划管理的工作经验;</p>-->
<!--        <p>4.具备地产策划推广整体思维、新媒体营销思维，对活动落地执行、费用管控有管理思路和方法，并具有较高的审美水平;</p>-->
<!--        <p>5.有较强的沟通能力，思路清晰、执行力强。</p>-->
<!--      </div>-->
<!--      <div class="newsdetail-work-title">-->
<!--        <p>联系方式&简历投递:</p>-->
<!--        <p>18921097122(微信同号) </p>-->
<!--        <p>DCHR@jiahonggroup.com</p>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import topNav from '@/components/base/top-nav'
import {fetchDict,fetchDetail} from '@/api/join.js'
import {formatTime} from '@/utils';
export default {
  name: "joindetail",
  components:{
    topNav
  },
  data() {
    return {
      addressArr:[],
      typeArr:[],
      salaryArr:[],
      dataInfo:{}
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getDictList()
    this.fetchData()
  },
  methods: {
    getDictList(){
      // 工作地点
      let work_address = 'work_address'
      fetchDict(work_address).then(res=>{
        this.addressArr = res.data
      })
      // 岗位类型
      let post_type = 'post_type'
      fetchDict(post_type).then(res=>{
        this.typeArr = res.data
      })
      //薪资
      let work_salary = 'work_salary'
      fetchDict(work_salary).then(res=>{
        this.salaryArr = res.data
      })
    },
    getDictText(arr,type){
      for(let item of arr){
        if(item.value == type){
          return item.label
        }
      }
    },
    fetchData(){
      fetchDetail({id:this.id}).then(res=>{
        this.dataInfo = res.data;
        this.dataInfo.createTime = formatTime(this.dataInfo.createTime,'yyyy-MM-dd')
      })
    },
    /**
     * 职位搜索
     */
    onSearch(){

    },
    addressChange(e){
      console.log("e====",e)
    },
    cateChange(e){
      console.log("e22====",e)
    },
    workClick(item,index){
      this.$router.push('/about')
    }
  }
}
</script>

<style>
  @import "../../styles/joindetail.css";
</style>
